export default __webpack_public_path__ + "static/media/juggernaut.96e18c35.png";